// FILE: /src/hooks/useSocialConnect.js (FULLY UPDATED)

import { useState, useCallback } from 'react';
import { message } from 'antd';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import * as authServices from '../services/authConnect';
import { fetchBillingDetails } from '../services/user.profile';
import UpgradeModal from '../Components/BuySubscription/UpgradeModal';
import { handleAuthSuccess } from '../store/Slices/GroupSlice';
import {
  clearSocialConnectOrigin,
  setSocialConnectOrigin,
} from '../utils/socialConnectOrigin';

export const useSocialConnect = (options = {}) => {
    const [status, setStatus] = useState('idle');
    const [upgradeModal, setUpgradeModal] = useState({ visible: false, message: '', featureName: '' });
    const dispatch = useDispatch();

const {
  groups,
} = useSelector(
  (state) => state.groups
);

    const connect = useCallback(async (platform, groupName) => {
        if (status === 'connecting') {
            message.info("A connection process is already in progress.");
            return;
        }
        if (!groupName) {
            message.error("Please select a brand/group before connecting.");
            return;
        }
        
        try {
            setStatus('connecting');
            const { usage, limits } = await fetchBillingDetails();

            if (usage.profileCount >= limits.profiles) {
                setUpgradeModal({
                    visible: true,
                    message: `You have reached your limit of ${limits.profiles} connected social profiles. Please upgrade your plan to add more.`,
                    featureName: 'Social Profiles',
                });
                setStatus('idle');
                return;
            }

            sessionStorage.setItem(
                'temp_selected_group_for_auth',
                groupName
                );

                sessionStorage.setItem(
                'authRedirectPath',
                window.location.pathname +
                    window.location.search
                );

                if (options.source === 'copilot') {
  const selectedGroup =
    Array.isArray(groups)
      ? groups.find(
          (group) =>
            String(
              group?.name || ""
            ) ===
            String(
              groupName || ""
            )
        )
      : null;

  const sessionId =
    options.sessionId
      ? String(
          options.sessionId
        )
      : null;

  const exactReturnPath =
    sessionId
      ? `/Dashboard?copilotSession=${encodeURIComponent(
          sessionId
        )}`
      : "/Dashboard";

  setSocialConnectOrigin({
  source: 'copilot',
  sessionId,
  groupName,
  platform,
  requestedPlatforms:
    Array.isArray(
      options.requestedPlatforms
    )
      ? options.requestedPlatforms
      : [platform],
  returnPath:
    exactReturnPath,
  connectedAccounts:
    selectedGroup
      ?.connected_accounts ||
    [],
});
} else {
  clearSocialConnectOrigin();
}

                const { authUrl } =
                await authServices.getAuthUrl(
                    platform,
                    groupName,
                    window.location.origin
                );

                window.location.href = authUrl;

        } catch (error) {
            if (error.response?.status === 403 && error.response?.data?.errorType === 'LIMIT_REACHED') {
                setUpgradeModal({
                    visible: true,
                    message: error.response.data.message,
                    featureName: `${platform.charAt(0).toUpperCase() + platform.slice(1).toLowerCase()} Connection`,
                });
            } else {
                message.error(error.message || `Could not start ${platform} connection process.`);
            }
            setStatus('idle');
        }
    }, [
  status,
  dispatch,
  options,
  groups,
]);

    const UpgradePrompt = () => (
        <UpgradeModal
            isOpen={upgradeModal.visible}
            onClose={() => setUpgradeModal({ visible: false, message: '', featureName: '' })}
            message={upgradeModal.message}
            featureName={upgradeModal.featureName}
        />
    );
    
    return { status, connect, UpgradePrompt };
};